import { render, staticRenderFns } from "./editAlerts.vue?vue&type=template&id=287d5952&scoped=true&"
import script from "./editAlerts.vue?vue&type=script&lang=js&"
export * from "./editAlerts.vue?vue&type=script&lang=js&"
import style0 from "./editAlerts.vue?vue&type=style&index=0&id=287d5952&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d5952",
  null
  
)

export default component.exports